var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOwl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 417.189 417.189",
    style: {
      enableBackground: "new 0 0 417.189 417.189"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#AEB1B3"
    },
    cx: 214.372,
    cy: 275.176,
    r: 131.604
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C5C7C7"
    },
    cx: 214.372,
    cy: 302.864,
    rx: 14.368,
    ry: 25.347
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C5C7C7"
    },
    cx: 184.633,
    cy: 344.089,
    rx: 14.368,
    ry: 25.347
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C5C7C7"
    },
    cx: 214.372,
    cy: 302.864,
    rx: 14.368,
    ry: 25.347
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C5C7C7"
    },
    cx: 184.633,
    cy: 344.089,
    rx: 14.368,
    ry: 25.347
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C5C7C7"
    },
    cx: 244.111,
    cy: 344.089,
    rx: 14.368,
    ry: 25.347
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#222222"
    },
    d: "M214.372,143.571c-72.683,0-131.604,58.923-131.604,131.605    c0,72.683,58.921,131.603,131.604,131.603V143.571z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#222222"
    },
    d: "M192.848,273.468c0.839-11.735-1.075-23.486-5.676-34.504    c-11.828-28.327-39.309-46.632-70.007-46.632c-1.742,0-3.477,0.081-5.206,0.201c-18.253,22.59-29.191,51.336-29.191,82.643    c0,42.767,20.403,80.76,51.999,104.798c1.054-1.157,2.039-2.384,2.935-3.685l0.325-0.474l0.023-0.044    c0.382-0.577,0.745-1.166,1.087-1.755c1.985-3.064,5.196-7.642,8.902-12.929c11.305-16.127,28.385-40.491,37.347-59.765    c1.274-2.624,2.387-5.271,3.268-7.762c1.298-3.52,2.175-6.612,2.679-9.451l0.042-0.229c0.37-1.75,0.68-3.505,0.926-5.266    l0.915-5.178L192.848,273.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M179.42,233.039c-14.351-34.368-53.847-50.597-88.216-36.242    c-34.367,14.353-50.594,53.848-36.242,88.217l30.318,72.605c5.549,13.282,20.812,19.554,34.094,14.005    c4.793-2,8.668-5.273,11.408-9.258h0.002c0.002-0.006,0.006-0.01,0.008-0.016c0.418-0.607,0.811-1.232,1.173-1.87    c8.061-12.497,34.227-46.917,45.837-71.926c1.118-2.298,2.12-4.651,2.971-7.062c1.066-2.889,1.86-5.588,2.292-8.014l-0.017,0.001    C185.931,260.401,184.974,246.337,179.42,233.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#222222"
    },
    d: "M56.919,289.699l28.361,67.92c5.549,13.282,20.812,19.554,34.094,14.005    c4.793-2,8.668-5.273,11.408-9.258h0.002c0.002-0.006,0.006-0.01,0.008-0.016c0.418-0.607,0.811-1.232,1.173-1.87    c7.939-12.308,33.431-45.879,45.291-70.781H56.919z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#222222"
    },
    d: "M235.896,273.468c-0.839-11.735,1.075-23.486,5.677-34.504    c11.827-28.327,39.308-46.632,70.006-46.632c1.742,0,3.477,0.081,5.205,0.201c18.256,22.59,29.191,51.336,29.191,82.643    c0,42.767-20.403,80.76-51.999,104.798c-1.055-1.157-2.038-2.384-2.934-3.685l-0.326-0.474l-0.023-0.044    c-0.382-0.577-0.745-1.166-1.087-1.755c-1.986-3.064-5.195-7.642-8.901-12.929c-11.306-16.127-28.388-40.491-37.347-59.765    c-1.275-2.624-2.389-5.271-3.268-7.762c-1.299-3.52-2.174-6.612-2.68-9.451l-0.04-0.229c-0.372-1.75-0.682-3.505-0.929-5.266    l-0.914-5.178L235.896,273.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M249.323,233.039c14.352-34.368,53.847-50.597,88.217-36.242    c34.367,14.353,50.594,53.848,36.242,88.217l-30.318,72.605c-5.549,13.282-20.813,19.554-34.094,14.005    c-4.793-2-8.668-5.273-11.408-9.258h-0.002c-0.002-0.006-0.007-0.01-0.009-0.016c-0.417-0.607-0.81-1.232-1.172-1.87    c-8.06-12.497-34.226-46.917-45.837-71.926c-1.117-2.298-2.119-4.651-2.971-7.062c-1.068-2.889-1.859-5.588-2.291-8.014    l0.016,0.001C242.812,260.401,243.769,246.337,249.323,233.039z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#222222"
    },
    d: "M371.825,289.699l-28.361,67.92c-5.549,13.282-20.813,19.554-34.094,14.005    c-4.793-2-8.668-5.273-11.408-9.258h-0.002c-0.002-0.006-0.007-0.01-0.009-0.016c-0.417-0.607-0.81-1.232-1.172-1.87    c-7.939-12.308-33.431-45.879-45.292-70.781H371.825z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A4A9AD"
    },
    cx: 214.371,
    cy: 127.207,
    r: 127.173
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M167.711,8.904c-55.602,21.932-87.104,78.688-79.379,135.382    c-1.308-23.273,12.22-45.78,35.092-54.801c28.545-11.26,60.818,2.754,72.078,31.302l9.395,23.819l28.278-11.154l-9.396-23.818    c-11.26-28.548,2.755-60.818,31.304-72.079c22.869-9.019,48.117-1.81,63.051,16.088C285.077,6.94,223.311-13.027,167.711,8.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#222222"
    },
    d: "M167.711,8.904c-65.337,25.771-97.412,99.628-71.642,164.966    c25.772,65.338,99.629,97.412,164.965,71.64L167.711,8.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5C7C7"
    },
    d: "M111.099,90.17c23.463-9.254,49.986,2.264,59.239,25.726l4.895,12.403l-50.417-21.895    c-8.445,3.332-60.515,23.868-60.515,23.868c-10.346,4.08-22.038-0.998-26.119-11.343L111.099,90.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M117.034,108.417c23.463-9.255,49.986,2.264,59.24,25.727l-45.523-9.492    c-8.444,3.332-60.516,23.87-60.516,23.87c-10.346,4.079-22.037-0.998-26.118-11.344L117.034,108.417z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 143.81,
    cy: 141.175,
    r: 33.954
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333E48"
    },
    cx: 143.81,
    cy: 141.176,
    r: 10.673
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDD3D"
    },
    d: "M244.21,130.352c0.949-6.229-3.43-11.297-9.729-11.261l-11.8,0.071     c-6.3,0.036-15.243,3.564-19.872,7.841l-8.67,8c-4.627,4.273-4.368,10.964,0.574,14.87l32.54,25.692     c4.946,3.905,9.77,2.001,10.719-4.227L244.21,130.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#222222"
    },
    d: "M202.809,127.003l-8.67,8c-4.627,4.273-4.368,10.964,0.574,14.87l32.54,25.692     c2.473,1.951,4.916,2.449,6.857,1.685l-21.991-55.758C208.518,122.914,205.125,124.865,202.809,127.003z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5C7C7"
    },
    d: "M264.617,29.675c-23.469,9.241-35.005,35.755-25.765,59.223l4.883,12.407l21.927-50.402    c8.448-3.326,60.53-23.83,60.53-23.83C336.54,23,341.625,11.309,337.553,0.961L264.617,29.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C6670"
    },
    d: "M272.724,47.066c-23.469,9.238-35.003,35.755-25.766,59.223l26.811-37.995    c8.448-3.324,60.532-23.83,60.532-23.83c10.346-4.074,15.432-15.763,11.358-26.11L272.724,47.066z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 275.493,
    cy: 89.285,
    r: 33.954
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333E48"
    },
    cx: 275.493,
    cy: 89.286,
    r: 10.673
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA21F"
    },
    d: "M261.874,417.189c-4.143,0-7.5-3.357-7.5-7.5v-29.628c0-4.143,3.357-7.5,7.5-7.5    c4.143,0,7.5,3.357,7.5,7.5v29.628C269.374,413.832,266.017,417.189,261.874,417.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA21F"
    },
    d: "M232.531,417.189c-4.143,0-7.5-3.357-7.5-7.5v-29.628c0-4.143,3.357-7.5,7.5-7.5    c4.143,0,7.5,3.357,7.5,7.5v29.628C240.031,413.832,236.674,417.189,232.531,417.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDD3D"
    },
    d: "M247.202,417.189c-4.143,0-7.5-3.357-7.5-7.5v-29.628c0-4.143,3.357-7.5,7.5-7.5    c4.143,0,7.5,3.357,7.5,7.5v29.628C254.702,413.832,251.345,417.189,247.202,417.189z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA21F"
    },
    d: "M155.518,417.189c-4.143,0-7.5-3.357-7.5-7.5v-29.628c0-4.143,3.357-7.5,7.5-7.5    c4.143,0,7.5,3.357,7.5,7.5v29.628C163.018,413.832,159.661,417.189,155.518,417.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA21F"
    },
    d: "M184.861,417.189c-4.143,0-7.5-3.357-7.5-7.5v-29.628c0-4.143,3.357-7.5,7.5-7.5s7.5,3.357,7.5,7.5    v29.628C192.361,413.832,189.004,417.189,184.861,417.189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEDD3D"
    },
    d: "M170.19,417.189c-4.143,0-7.5-3.357-7.5-7.5v-29.628c0-4.143,3.357-7.5,7.5-7.5    c4.143,0,7.5,3.357,7.5,7.5v29.628C177.69,413.832,174.333,417.189,170.19,417.189z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwl);
export default __webpack_public_path__ + "static/media/owl.b9a17c27790fc5c49512c3465bbcc527.svg";
export { ForwardRef as ReactComponent };